import { Readable, Comment } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import { PlusIcon } from '@heroicons/react/24/solid'
import Avatar from '@/components/atoms/Avatar'
import CommentForm from './CommentForm'

interface IProps {
  readable: Readable
  replyIds: Number[]
  comment: Comment
  handleResponseClick: (e: any) => void
  updateCommentsList: (e: any) => void
}

const CommentsTree = ({
  readable,
  handleResponseClick,
  comment,
  updateCommentsList,
  replyIds,
}: IProps) => {
  const { t, lang } = useTranslation('common')

  return (
    <article key={comment.id} className='mb-10 '>
      <header className='flex items-center align-center'>
        {comment.creator?.avatar?.url ? (
          <span className={` rounded-full`}>
            <Avatar
              url={comment.creator?.avatar?.url}
              className='w-10 md:w-auto'
            />
          </span>
        ) : null}
        <p className='ml-4 text-xl'>
          {comment.creator?.displayedName
            ? comment.creator?.displayedName
            : 'Anonymous'}
        </p>

        {comment.createdAt && (
          <p className='ml-2 text-xl text-gray-500'>
            {new Date(comment.createdAt).toLocaleDateString(
              lang === 'pl' ? 'pl-PL' : 'en-US',
              { year: 'numeric', month: 'numeric', day: 'numeric' }
            )}
          </p>
        )}
      </header>
      <div
        className='pl-14 md:pl-18 font-normal'
        dangerouslySetInnerHTML={{
          __html: comment.htmlContent ? comment.htmlContent : '',
        }}
      />
      <div className='pl-14 md:pl-18 mt-4'>
        <button
          type='button'
          className='flex items-center'
          onClick={handleResponseClick}
          data-commentid={comment.id}
        >
          <PlusIcon width={16} className='mr-2 -mt-0.5' /> {t('common:answer')}
        </button>
        {replyIds.includes(+comment.id) && (
          <div className='mt-6'>
            <CommentForm
              readable={readable}
              updateCommentsList={updateCommentsList}
              commentId={+comment.id}
            />
          </div>
        )}
      </div>

      {
        // @ts-ignore
        comment.children &&
          // @ts-ignore
          comment.children.map((item, index) => (
            <div className='pl-14 md:pl-24 mt-4' key={index}>
              <CommentsTree
                readable={readable}
                handleResponseClick={handleResponseClick}
                comment={item}
                updateCommentsList={updateCommentsList}
                replyIds={replyIds}
              />
            </div>
          ))
      }
    </article>
  )
}

export default CommentsTree
